module.exports = "/_next/static/images/AIAndML-xs@2x-d13970107f2497e83caf7a034e3e2052.webp";